export const ACTION_GET_SCREEN = "ACTION_GET_SCREEN";
export const ACTION_GET_SCREEN_SUCCESS = "ACTION_GET_SCREEN_SUCCESS";


/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/